module.exports = {
  tabbarHeight: 48
};
